<template>
    <div class="formgrid grid p-fluid">
        <i
            class="fa fa-bars fa-lg icon-button ml-1 text-primary"
            title="Metas"
            @click.stop="abrirModal()"
        >
        </i>
        <b-modal
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            no-enforce-focus
            @show="preencherModalConsultoria()"
        >
            <div slot="modal-title">
                Meta da Consultoria - Convenio: {{ evento.idConvenio }}
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">CPF/CNPJ do Cliente</label>
                            <b-input-group>
                                <b-form-input v-mask="cpfCnpjMask()"  type="search"
                                    v-model="cpfCliente">
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo do Cliente</label>
                            <b-form-select
                                :options="tiposClientes"
                                v-model="tipoCliente"
                                optionLabel="descricao"
                                optionValue="codigo"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Código do Cliente</label>
                            <b-input-group>
                                <b-form-input type="number" maxlength="15" v-model="codCliente">
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Início Atendimento</label>
                            <b-input-group>
                                <date-picker
                                    v-mask="'##/##/####'"
                                    :config="$datePickerOptions2"
                                    v-model="inicioAtendimento"
                                >
                                </date-picker>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Final Atendimento</label>
                            <b-input-group>
                                <date-picker
                                    v-mask="'##/##/####'"
                                    :config="$datePickerOptions2"
                                    v-model="finalAtendimento"
                                >
                                </date-picker>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tipo</label>
                            <b-input-group>
                                <b-form-select
                                    :options="tipos"
                                    v-model="selectedTipo"
                                    optionLabel="descricao"
                                    optionValue="codigo"
                                    disabled
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Abordagem</label>
                            <b-input-group>
                                <b-form-select
                                    :options="abordagens"
                                    v-model="abordagem"
                                    optionLabel="descricao"
                                    optionValue="codigo"
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label>CPF do Gestor Responsável</label>
                            <b-input-group>
                                <b-form-input
                                    v-mask="'###.###.###-##'"
                                    type="text"
                                    v-model="cpfResponsavel"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="4">
                        <b-form-group>
                            <label class="required">Carga Horária</label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    v-model="cargaHoraria"
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="8">
                        <b-form-group>
                            <label class="required">Título</label>
                            <b-input-group>
                                <b-form-input maxlength="255" type="text" v-model="tituloAtendimento"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Projeto</label>
                            <b-input-group>
                                <!-- <b-spinner small></b-spinner> -->
                                <b-form-select
                                    :options="projeto"
                                    v-model="codProjeto"
                                    text-field="nomePratif"
                                    value-field="codPratif"
                                    @change="updateSelectedProjeto()"
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="18" md="3">
                        <b-form-group>
                            <label class="required">Ação</label>
                            <b-input-group>
                                <b-form-select
                                    :options="acoes"
                                    v-model="codAcao"
                                    text-field="nomeAcao"
                                    value-field="codAcaoSeq"
                                    @change="updateSelectedAcao()"
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Instrumento</label>
                            <b-input-group>
                                <b-form-select
                                    :options="instrumentos"
                                    v-model="codInstrumento"
                                    text-field="descCategoria"
                                    value-field="codCategoria"
                                    @change="updateSelectedInstrumento()"
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="3">
                        <b-form-group>
                            <label class="required">Tema</label>
                            <b-input-group>
                                <b-form-select
                                    :options="tema"
                                    v-model="codTema"
                                    text-field="descAreaTematica"
                                    value-field="codAreaTematica"
                                    @input="updateSelectedTema()"
                                ></b-form-select>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label>Código de Realização</label>
                            <b-input-group>
                                <b-form-input
                                    type="number"
                                    v-model="codRealizacao"
                                    disabled
                                >
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="3">
                        <b-form-group>
                            <label class="required">Tipo da Realização</label>
                            <b-input-group>
                                <b-form-input
                                    type="text"
                                    v-model="tipoRealizacao"
                                    disabled
                                >
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="24" md="12">
                        <b-form-group>
                            <label class="text-nowrap required"
                                >Descrição do Atendimento</label
                            >
                            <b-input-group>
                                <b-form-input type="text" maxlength="255" v-model="descricaoAtendimento"></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Fechar
                </b-button>
            </div>
            <b-card no-body>
                <b-card-header>
                    <span class="h5"> Metas da Consultoria </span>
                </b-card-header>
                <b-card-body>
                    <app-tabela
                        :itens="metasConsultorias"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false"
                    >
                        <template slot="botoes">
                            <b-button-group class="float-right">
                                <b-button
                                    variant="success"
                                    :disabled="$v.$invalid"
                                    @click="inserirMetaConsultoria()"
                                    class="ml-1"
                                >
                                    Inserir Meta da Consultoria
                                </b-button>
                            </b-button-group>
                        </template>

                        <template slot="acoes" slot-scope="data">
                            <span class="text-secondary float-left mr-1">
                                <b-button-group class="float-right">
                                    <documentos-consultoria
                                        :dataServicos="dataServicos"
                                        :metaConsultoria="data"
                                        @atualizarLista="atualizarConsultorias()">
                                    </documentos-consultoria>
                                    <!-- <btn-cancelar-meta :evento="evento" :meta="data" :dataServicos="dataServicos"
                                        @fecharModal="fecharModal()"
                                        @abrirModal="abrirModal()">
                                    </btn-cancelar-meta> -->
                                </b-button-group>
                            </span>
                        </template>
                        <!-- <template slot="situacao" slot-scope="data">
                            <app-status :status="data.situacao.toUpperCase()"></app-status>
                        </template> -->
                    </app-tabela>
                </b-card-body>
            </b-card>
        </b-modal>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import DocumentosConsultoria from '../DocumentosConsultoria'
import BtnCancelarMeta from './BtnCancelarMeta'
import BtnInserirMeta from './BtnInserirMeta'

export default {
    components: {
        BtnInserirMeta,
        BtnCancelarMeta,
        DocumentosConsultoria
    },

    props: {
        evento: {
            type: Object,
            default: () => ({})
        },

        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },

        permiteInserirMetas: {
            type: Boolean,
            default: false
        },

        permiteCancelarMetas: {
            type: Boolean,
            default: false
        }
    },

    validations: {
        cpfCliente: { required },
        codCliente: { required },
        tipoCliente: { required },
        inicioAtendimento: { required },
        finalAtendimento: { required },
        selectedTipo: { required },
        abordagem: { required },
        cargaHoraria: { required },
        tituloAtendimento: { required },
        tipoRealizacao: { required },
        descricaoAtendimento: { required },
        codTema: { required },
        codInstrumento: { required },
        codAcao: { required },
        codProjeto: { required }
    },

    data() {
        return {
            codInstrumento: null,
            quantidade: null,
            codAcao: null,
            codProjeto: null,
            codTema: null,
            cpfCliente: null,
            tipoCliente: null,
            codCliente: null,
            inicioAtendimento: null,
            finalAtendimento: null,
            abordagem: null,
            cpfResponsavel: null,
            cargaHoraria: null,
            tituloAtendimento: null,
            projeto: [],
            acoes: [],
            tipoRealizacao: '',
            nomeAcao: null,
            descricaoAcao: '',
            descricaoProjeto: '',
            descricaoInstrumento: '',
            codRealizacao: null,
            descricaoTema: '',
            acaoConsultoria: null,
            tema: [],
            metasConsultorias: null,
            descricaoAtendimento: null,
            consultoriaDto: null,
            idAcaoPlanoTrabalho: null,
            idConsultoria: null,
            totalPrevisto: null,
            totalRealizado: null,
            mostrarModal: false,
            erros: [],
            itensPorPagina: 5,
            metas: [],
            selectedTipo: 0,
            abordagens: [
                { value: 0, text: 'INDIVIDUAL' },
                { value: 1, text: 'GRUPAL' },
                { value: 2, text: 'UNIVERSAL' }
            ],
            tipos: [{ value: 0, text: 'Consultoria Convênio Transferência' }],
            instrumentos: [],

            tiposClientes: [
                { value: 0, text: 'CNPJ' },
                { value: 1, text: 'CPF' }
            ],
            campos: [
                {
                    key: 'nomeMeta',
                    label: 'Nome da Meta',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'totalRealizado',
                    label: 'Total Realizado(Horas)',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ]
        }
    },
    computed: {
        cpfCnpjPlaceholder() {
            return this.tipoCliente == '1'
                ? '###.###.###-##'
                : '##.###.###/####-##'
        }
    },
    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.erros=[];
            this.limparCampos();
            this.obterProjetos();
            this.obterInstrumentos();
            this.obterAcoes();
            this.obterTemas();
            this.erros = [];
            if( this.evento.idConsultoria ){
                this.obterMetasConsultoria(this.evento.idConsultoria);
            }
        },
        obterMetasConsultoria(id) {
            this.dataServicos.obterMetasConsultoria(id).then((response) => {
                if (response) {
                    if (response.success) {
                        this.metasConsultorias = response.data
                            ? response.data
                            : []
                    } else {
                        this.erros.push(response.errors)
                    }
                }
                // this.$store.dispatch('removeRequest')
            })
        },
        updateSelectedAcao() {
            const selected = this.acoes.find(acao => acao.codAcaoSeq === this.codAcao);
            this.descricaoAcao = selected ? selected.nomeAcao : '';
        },
        updateSelectedProjeto() {
            const selected = this.projeto.find(acao => acao.codPratif === this.codProjeto);
            this.descricaoProjeto = selected ? selected.nomePratif : '';
        },
        updateSelectedTema() {
            const selected = this.tema.find(acao => acao.codAreaTematica === this.codTema);
            this.descricaoTema = selected ? selected.descAreaTematica : '';
        },
        updateSelectedInstrumento() {
            const selected = this.instrumentos.find(
                (acao) => acao.codCategoria === this.codInstrumento
            )
            this.descricaoInstrumento = selected ? selected.descCategoria : ''
        },
        cpfCnpjMask() {
            return this.tipoCliente == '1'
                ? '###.###.###-##'
                : '##.###.###/####-##'
        },
        obterProjetos() {
            //obterProjetos
            // this.$store.dispatch('addRequest')
            this.dataServicos.obterProjetosSas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.projeto = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors)
                        }
                    }
                })
                // this.$store.dispatch('removeRequest')
            }
        ,
        obterAcoes() {
            // obterAcoes
            // this.$store.dispatch('addRequest')
            this.dataServicos.obterAcoesSas().then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data ? response.data : []
                        } else {
                            this.erros.push(response.errors);
                        }
                    }
                })
                //this.$store.dispatch('removeRequest')
            }
        ,
        obterInstrumentos() {
            // obterTiposInstrumento
            //  this.$store.dispatch('addRequest')

            this.dataServicos.obterTiposInstrumento().then((response) => {
                if (response) {
                    if (response.success) {
                        this.instrumentos = response.data ? response.data : []
                    } else {
                        this.erros.push(response.errors)
                    }
                }
                // this.$store.dispatch('removeRequest')
            })
        },
        obterTemas() {
            // obterTemas
            // this.$store.dispatch('addRequest')
            this.dataServicos.obterTemasSas().then((response) => {
                if (response) {
                    if (response.success) {
                        this.tema = response.data ? response.data : []
                    } else {
                        this.erros.push(response.errors)
                    }
                }
                //  this.$store.dispatch('removeRequest')
            })
        },
        preencherModalConsultoria() {
            if (this.evento != null) {
                this.consultoriaDto = this.evento
                this.tipoRealizacao = "CON"
            }
        },

        fecharModal() {
            this.mostrarModal = false
            this.consultoriaDto = null
        },
        limparCampos(){

            this.cpfCliente = 0,
            this.tipoCliente = 0,
            this.codCliente = 0,
            // this.tema = [{
            //         descAreaTematica:  "",
            //         codAreaTematica: 0
            //     }]
            //     this.instrumentos = [{
            //         descCategoria: "",
            //         codCategoria: 0
            //     }]
            //     this.acoes = [{
            //         nomeAcao:  "",
            //         codAcaoSeq: 0
            //     }]
            //     this.projeto = [{
            //         nomePratif:  "",
            //         codPratif: 0
            //     }]
            this.inicioAtendimento = "",
            this.finalAtendimento = "",
            this.abordagem = [{
                    descricao:  "",
                    codigo: 0
                }]
            this.cpfResponsavel = "",
            this.cargaHoraria = 0,
            this.tituloAtendimento = "",
            this.descricaoAtendimento = ""

        },
        
        inserirMetaConsultoria() {
            
            this.$store.dispatch('addRequest')
            this.consultoriaDto.nomeMeta = this.evento.nomeConsultoria,
            this.consultoriaDto.cpfCliente = this.cpfCliente ? this.cpfCliente.replace(/[^0-9]/g, '') : 0,
            this.consultoriaDto.tipoCliente = this.tipoCliente,
            this.consultoriaDto.codCliente = this.codCliente,
            this.consultoriaDto.inicioAtendimento = this.$moment(this.inicioAtendimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            this.consultoriaDto.finalAtendimento = this.$moment(this.finalAtendimento, 'DD/MM/YYYY').format('YYYY-MM-DD'),
            this.consultoriaDto.abordagem = this.abordagem,
            this.consultoriaDto.cpfResponsavel = this.cpfResponsavel ? this.cpfResponsavel.replace(/[^0-9]/g, '') : 0,
            this.consultoriaDto.cargaHoraria = this.cargaHoraria,
            this.consultoriaDto.totalRealizado = this.cargaHoraria,
            this.consultoriaDto.tituloAtendimento = this.tituloAtendimento,
            this.consultoriaDto.nomeMeta = this.tituloAtendimento,
            this.consultoriaDto.acaoConsultoria = this.acaoConsultoria,
            this.consultoriaDto.codTema = this.codTema,
            this.consultoriaDto.codAcao = this.codAcao,
            this.consultoriaDto.codProjeto = this.codProjeto,
            this.consultoriaDto.codInstrumento = this.codInstrumento,
            this.consultoriaDto.acao = this.descricaoAcao ? this.descricaoAcao : this.evento.acao,
            this.consultoriaDto.tema = this.descricaoTema ? this.descricaoTema : this.evento.tema,
            this.consultoriaDto.projeto = this.descricaoProjeto ? this.descricaoProjeto : this.evento.projeto,
            this.consultoriaDto.instrumento = this.descricaoInstrumento ? this.descricaoInstrumento : this.evento.instrumento,
            this.consultoriaDto.descricaoAtendimento = this.descricaoAtendimento,
            this.consultoriaDto.codRealizacao = parseInt(this.$moment(Date.now()).format('DDMMYYYYMMHHSS'), 10),
            this.consultoriaDto.tipoRealizacao = this.tipoRealizacao,
            this.consultoriaDto.idConvenio = this.evento.idConvenio
           
            this.dataServicos.inserirMetaConsultoria(this.consultoriaDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Meta de Consultoria inserida com sucesso!',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.obterMetasConsultoria(this.evento.idConsultoria);
                        this.$emit('atualizarLista')
                      //  this.fecharModal()
                    } else {
                        this.$emit('atualizarErros', response.errors);
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            //Inserir no Historico Cliente no Sas
            this.$store.dispatch('addRequest')
  
            let HistoricoSasDto = {
                CodCliente: this.codCliente,
                CodEmpreendimento: 0,
                DataHoraInicioRealizacao: this.$moment(this.inicioAtendimento, 'DD/MM/YYYY').format('MM/DD/YYYY HH:mm:ss'),
                DataHoraFimRealizacao:  this.$moment(this.finalAtendimento, 'DD/MM/YYYY').format('MM/DD/YYYY HH:mm:ss'),
                NomeRealizacao: this.tituloAtendimento,
                CodRealizacao: this.codRealizacao ? this.codRealizacao : 0,
                TipoRealizacao: this.tipoRealizacao ? this.tipoRealizacao : 0,
                CodRealizacaoComp: this.abordagem,
                Instrumento: this.descricaoInstrumento,
                Abordagem:
                    this.abordagem == 0
                        ? 'I'
                        : this.abordagem == 1
                        ? 'G'
                        : this.abordagem == 2
                        ? 'U'
                        : ' ',
                DescRealizacao: this.descricaoAcao ? this.descricaoAcao : ' ',
                CodProjeto: this.codProjeto,
                CodAcao: this.codAcao,
                MesAnoCompetencia: this.$moment(this.inicioAtendimento, 'DD/MM/YYYY').format('MM/YYYY'),
                CargaHoraria: this.cargaHoraria,
                CodSebrae: 17,
                CodTema: this.codTema,
                CodSistemaOrigem: 0, //0(zero) para não informar o CodSistemaOrigem
                CpfResponsavel: this.cpfResponsavel
                    ? this.cpfResponsavel.replace(/[^0-9]/g, '')
                    : 0
            }

            this.dataServicos
                .inserirHistoricoSas(HistoricoSasDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Historico inserido com sucesso',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('atualizarLista')
                            // this.fecharModal()
                        } else {
                            this.$emit('atualizarErros', response.errors)
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            this.limparCampos()
        }
        
    }
}
</script>
